export default [
    {
        path: 'relatorio-procedimento-lancado-periodo',
        component: () => import(
            /* webpackChunkName: 'ambulatorio-relatorio-procedimento-lancado-periodo' */
            '@/views/ambulatorio/relatorio-procedimento-lancado-periodo/Index'
        ),
        redirect: 'relatorio-procedimento-lancado-periodo/index',
        children: [
            {
                name: 'ambulatorio-relatorio-procedimento-lancado-periodo-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'ambulatorio-relatorio-procedimento-lancado-periodo' */
                    '@/views/ambulatorio/relatorio-procedimento-lancado-periodo/List.vue'
                ),
            },
        ],
    },
]